<template>
  <v-container>
    <carga-ciclo-semestre titulo="Respaldar periodo:" :datos="periodo" />

    <v-divider />

    <v-card
      ><v-card-text>
        <h3 style="text-align: center" class="py-4">
          ¿Quieres respaldar el estado actual de la carga académica y tutoría
          del periodo seleccionado?
        </h3>
        <v-row>
          <v-col cols="6" style="text-align: center"
            ><v-btn
              block
              height="60px"
              color="primary"
              @click.stop="dialog = true"
              >Si</v-btn
            ></v-col
          >
          <v-col cols="6" style="text-align: center"
            ><v-btn
              block
              height="60px"
              color="secondary"
              :to="
                '/carga-academica/' +
                (periodoActual ? 'periodo-actual' : 'proximo-periodo')
              "
              >No</v-btn
            ></v-col
          >
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Nota para el respaldo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Nota"
                  required
                  v-model="nota"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="realiza_respaldo"
            :disabled="nota == ''"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading-wait :loading="loading" />

    <v-snackbar v-model="snackbar" multi-line>
      <strong>{{ snacktext }}</strong>
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false"
          >Cerrar</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import api from "@/api";
import CargaCicloSemestre from "@/components/CargaCicloSemestre.vue";
import LoadingWait from "@/components/LoadingWait.vue";
import { gets } from "@/mixins/gets";

export default {
  name: "Respaldo",

  components: { CargaCicloSemestre, LoadingWait },

  props: {
    periodoSeleccionado: {
      type: String,
      required: true,
    },
  },

  mixins: [gets],

  data: () => ({
    periodoActual: true,
    periodo: {},
    carga: {},
    tutorias: {},
    loading: false,
    snackbar: false,
    snacktext: "",
    dialog: false,
    nota: "",
  }),

  computed: {
    itemsCargaBak() {
      if (this.carga) {
        let items = this.carga;
        let result = Object.keys(items).map(function (key) {
          return {
            id: items[key].carga_id,
            periodo_id: items[key].periodo_id,
            grupo_id: items[key].grupo_id,
            plan_estudio_id: items[key].plan_estudio_id,
            docente_id: items[key].docente_id,
          };
        });
        return result;
      } else return null;
    },

    itemsTutoriasBak() {
      if (this.tutorias) {
        let items = this.tutorias;
        let result = Object.keys(items).map(function (key) {
          return {
            id: items[key].tutoria_id,
            periodo_id: items[key].periodo_id,
            grupo_id: items[key].grupo_id,
            docente_id: items[key].docente_id,
          };
        });
        return result;
      } else return null;
    },
  },

  watch: {},

  methods: {
    async realiza_respaldo() {
      this.dialog = false;
      let carga_bak = false;
      let tutoria_bak = false;
      this.loading = true;
      let response = await api.send({
        table: "respaldos",
        action: "insert",
        scope: "ind",
        data: {
          id: 0,
          periodo_id: this.periodo.id,
          respaldo_de: "C",
          respaldo_nota: this.nota,
          respaldo_json: JSON.stringify(this.itemsCargaBak),
          deleted: 0,
        },
      });
      if (response.status == 200) {
        carga_bak = true;
      }

      response = await api.send({
        table: "respaldos",
        action: "insert",
        scope: "ind",
        data: {
          id: 0,
          periodo_id: this.periodo.id,
          respaldo_de: "T",
          respaldo_nota: this.nota,
          respaldo_json: JSON.stringify(this.itemsTutoriasBak),
          deleted: 0,
        },
      });
      if (response.status == 200) {
        tutoria_bak = true;
      }
      if (carga_bak && tutoria_bak) {
        this.snacktext =
          "Se ha respaldado la CARGA y TUTORÍAS del periodo seleccionado.";
      } else if (carga_bak) {
        this.snacktext =
          "Se ha respaldado la CARGA, pero no se pudo respaldar TUTORÍAS del periodo seleccionado.";
      } else if (tutoria_bak) {
        this.snacktext =
          "Se ha respaldado la TUTORÍAS, pero no se pudo respaldar la CARGA del periodo seleccionado.";
      } else this.snacktext = "NO se ha podido realizar ningún respaldo.";
      this.snackbar = true;
      setTimeout(() => {
        this.loading = false;
        this.$router.push(
          "/carga-academica/" +
            (this.periodoActual ? "periodo-actual" : "proximo-periodo")
        );
      }, 4000);
    },

    async set() {
      this.loading = true;
      if (this.periodoSeleccionado == "proximo-periodo") {
        this.periodoActual = false;
      } else if (this.periodoSeleccionado == "periodo-actual") {
        this.periodoActual = true;
      }
      this.periodo = await this.get(
        "periodos",
        this.periodoActual ? "actual" : "proximo"
      );
      this.carga = await this.get("cargas", {
        id: this.periodo.id,
      });
      this.tutorias = await this.get("tutorias", {
        id: this.periodo.id,
      });
      this.loading = false;
    },
  },

  async mounted() {
    this.$store.commit("setPageTitle", "Respaldo");
    this.set();
  },
};
</script>

<style>
.border-bottom {
  border-bottom: 1px solid darkgray;
}
.border-top {
  border-top: 1px solid darkgray;
}
</style>